var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-gray-50",attrs:{"dir":"rtl"}},[_c('div',{staticClass:"sticky top-0 z-10 bg-white border-b border-gray-200"},[_c('div',{staticClass:"flex"},[_c('button',{class:[
          'flex-1 py-4 px-4 text-center font-bold transition-all duration-200',
          _vm.active_tab === 0 
            ? 'bg-red-600 text-white' 
            : 'bg-white text-gray-700 hover:bg-gray-50'
        ],on:{"click":function($event){return _vm.set_active_tab(0)}}},[_vm._v(" پرداخت نشده ها ")]),_c('button',{class:[
          'flex-1 py-4 px-4 text-center font-bold transition-all duration-200',
          _vm.active_tab === 1 
            ? 'bg-green-600 text-white' 
            : 'bg-white text-gray-700 hover:bg-gray-50'
        ],on:{"click":function($event){return _vm.set_active_tab(1)}}},[_vm._v(" پرداخت شده ها ")])])]),(_vm.active_tab==0)?_c('div',[_c('UnpaidReports')],1):_vm._e(),(_vm.active_tab==1)?_c('div',[_c('PaidReports')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }